import { createContext, useContext, useState } from "react";

const AuthContext = createContext();
const MenuContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem("token") !== null);

    const login = (token) => {
        localStorage.setItem("token", token);
        setIsAuthenticated(true);
    };

    const logout = () => {
        localStorage.removeItem("token");
        setIsAuthenticated(false);
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const MenuProvider = ({ children }) => {
    const [menuIsCollapsed, setMenuIsCollapsed] = useState(false);

    const toggleCollapsed = () => {
        setMenuIsCollapsed((prev) => !prev);
    };

    return (
        <MenuContext.Provider value={{ menuIsCollapsed, toggleCollapsed }}>
            {children}
        </MenuContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
export const useMenu = () => useContext(MenuContext);